
import { defineComponent, computed } from 'vue'
import { useRoute } from 'vue-router'

const imgLight = require('@/assets/nodata_light_v.png')
const imgDark = require('@/assets/nodata_dark_v.png')

export default defineComponent({
  name: 'JfNoData',
  props: {
    /** light | dark，不传则读路由 query.theme，默认 light */
    theme: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const route = useRoute()
    const isDark = computed(() => {
      const t = props.theme || (route.query.theme as string) || 'light'
      return t === 'dark'
    })
    const imgSrc = computed(() => (isDark.value ? imgDark : imgLight))
    return { imgSrc, isDark }
  }
})
